import { render, staticRenderFns } from "./EmployeesView.vue?vue&type=template&id=3d80af5d&scoped=true&"
import script from "./EmployeesView.vue?vue&type=script&lang=js&"
export * from "./EmployeesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d80af5d",
  null
  
)

export default component.exports